import React, {Fragment} from 'react';

import _isEqual from "lodash/isEqual";
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {addCreditCard, resetCreditCard} from "../../../vendors/actions/creditCard";
import {Grid, InputAdornment, TextField} from "@material-ui/core";
import InputMask from "react-input-mask";


interface OwnProps {
    addCreditCard?: any,
    resetCreditCard?: any

    [key: string]: any
}

interface MainState {
    form: any,
}

interface ConnectStateProps {
    CreditCardForm: any
    User: any
}

interface ConnectDispatchProps {
    addCreditCard?: (data: any) => void;
    resetCreditCard?: (data: any) => void;
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


const CardNumberMask = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={'0000 0000 0000 0000'}
            mask="9999 9999 9999 9999"
            maskChar=""/>
    )
};

const ExpireDateMask = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={'MM/YY'}
            mask="99/99"
            maskChar=""/>
    )
};

const CvcMask = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={''}
            mask="9999"
            maskChar=""/>
    )
};

const PostalCodeMask = (props: any) => {
    const {...other} = props;
    return (
        <InputMask
            {...other}
            placeholder={''}
            mask="99999"
            maskChar=""/>
    )
};


class CreditCardForm extends React.Component<HeaderProps, MainState> {
    state = {
        form: {
            number: {
                value: '',
                cardType: '',
                error: false,
                dirty: false
            },
            exp_month: {
                value: '',
                error: false,
                dirty: false
            },
            exp_year: {
                value: '',
                error: false,
                dirty: false
            },
            cvc: {
                value: '',
                error: false,
                dirty: false
            },
            postal_code: {
                value: '',
                error: false,
                dirty: false
            }
        }
    };


    componentDidMount() {

    }

    componentWillUnmount() {
        this.props.resetCreditCard()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {CreditCardForm} = props;
        if (CreditCardForm && (!_isEqual(state.form, CreditCardForm.data))) {
            return {
                form: CreditCardForm.data
            };
        }

        return null;
    }

    private proceed(value: string | null | number, field: string,validate: boolean = false) {
        this.props.addCreditCard({value, field, validate});
    }

    addCardNumber = (e: any, validate: boolean = false) => {
        const value = e.target.value;
        this.proceed(value, 'number', validate);
    };


    addExpireDate = (e: any, validate: boolean = false) => {
        const value = e.target.value;
        let exp_month = null;
        let exp_year = null;
        if (value) {
            const date = value.split('/');
            if (date[0] && date[0].length === 2) {
                exp_month = parseInt(date[0])
            }
            if (date[1] && date[1].length === 2) {
                exp_year = parseInt(date[1])
            }
        }

        this.proceed(exp_month, 'exp_month', validate);
        this.proceed(exp_year, 'exp_year', validate);
    };

    addCvC = (e: any, validate: boolean = false) => {
        const value = e.target.value;
        this.proceed(value, 'cvc',validate);
    };

    addPostalCode = (e: any, validate: boolean = false) => {
        const value = e.target.value;
        this.proceed(value, 'postal_code',validate);
    };


    render() {
        const {form} = this.state;
        const cartType = (form.number.cardType || 'unknown').toLowerCase().replace(" ", "");

        return (
            <Fragment>

                <div className={'text-field-custom-mb card-number'}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Card Number"
                        error={!!form?.number?.error && form?.number?.dirty}
                        helperText={form?.number?.dirty && form?.number?.error ? form?.number?.error : ''}
                        onChange={this.addCardNumber}
                        onBlur={(e)=> this.addCardNumber(e, true)}
                        id="card-number"
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><span
                                className={`card-icon-holder card-icon-${cartType}`}/></InputAdornment>,
                            inputComponent: CardNumberMask,
                        }}
                    />
                    <div className={'brand-wrapper'}>
                        {/*<FontAwesomeIcon
                            icon={cartType}
                            className="font-size-xxl"
                        />*/}
                    </div>
                </div>
                <div className={'text-field-custom-mb card-number'}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Expiry Date"
                        error={(!!form?.exp_month?.error || !!form?.exp_year?.error) && (form?.exp_month?.dirty || form?.exp_year?.dirty)}
                        helperText={(form?.exp_month?.error || form?.exp_year?.error) && (form?.exp_month?.dirty || form?.exp_year?.dirty) ? form?.exp_month?.error || form?.exp_year?.error : ''}
                        onChange={this.addExpireDate}
                        onBlur={(e)=> {this.addExpireDate(e, true);}}
                        id="expire-date"
                        InputProps={{
                            inputComponent: ExpireDateMask,
                        }}
                    >
                    </TextField>
                </div>
                <div>
                    <Grid container spacing={3} className={'align-end'}>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            lg={6}
                            className="d-flex align-center">
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Zip Code"
                                error={!!form?.postal_code?.error && form?.postal_code?.dirty}
                                helperText={form?.postal_code?.error && form?.postal_code?.dirty ? form?.postal_code?.error : ''}
                                onChange={this.addPostalCode}
                                onBlur={(e)=> this.addPostalCode(e, true)}
                                id="postal-code"
                                InputProps={{
                                    inputComponent: PostalCodeMask,
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            lg={6}
                            className="d-flex align-center">
                            <TextField
                                fullWidth
                                error={!!form?.cvc?.error && form?.cvc?.dirty}
                                value={form?.cvc?.value || ''}
                                helperText={form?.cvc?.error && form?.cvc?.dirty ? form?.cvc?.error : ''}
                                onChange={this.addCvC}
                                onBlur={(e)=> this.addCvC(e, true)}
                                label="CVC"
                                id="cvc"
                                variant="outlined"
                                InputProps={{
                                    inputComponent: CvcMask,
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {CreditCardForm, User} = state;
    return {
        CreditCardForm,
        User
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        addCreditCard: (data: any) => dispatch(addCreditCard(data)),
        resetCreditCard: (data: any) => dispatch(resetCreditCard())
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(CreditCardForm);
